import RefreshIcon from "@mui/icons-material/Refresh";
import ScheduleIcon from "@mui/icons-material/Schedule";
import {
	Alert,
	Box,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { InstitutionDownloadConfigDto } from "Infrastructure/Api/Api";
import { useState } from "react";
import {
	DOWNLOAD_CONFIGS_QUERY_KEY,
	useDownloadConfigsQuery,
} from "../../Api/Queries/useDownloadConfigsQuery";
import { DownloadConfigDialog } from "./DownloadConfigDialog";
import { DownloadConfigTable } from "./DownloadConfigTable";

export const SourcesTab: React.FunctionComponent = () => {
	const [editConfig, setEditConfig] =
		useState<InstitutionDownloadConfigDto | null>(null);
	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(10);

	const queryClient = useQueryClient();
	const offset = page * pageSize;
	const { data, isLoading } = useDownloadConfigsQuery(null, offset, pageSize);

	const configs = data?.status === 200 ? data.data.items : [];
	const totalCount = data?.status === 200 ? data.data.totalCount : 0;
	const enabledCount = data?.status === 200 ? data.data.enabledCount : 0;
	const downloadScheduleCron =
		data?.status === 200 ? data.data.downloadScheduleCron : null;

	const handleRefresh = () => {
		queryClient.invalidateQueries({ queryKey: [DOWNLOAD_CONFIGS_QUERY_KEY] });
	};

	const handlePageChange = (newPage: number) => {
		setPage(newPage);
	};

	const handlePageSizeChange = (newPageSize: number) => {
		setPageSize(newPageSize);
		setPage(0);
	};

	return (
		<Box sx={{ px: 2 }}>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="flex-end"
			>
				<Alert severity="info" icon={<ScheduleIcon />} sx={{ mb: 3 }}>
					<Stack direction="row" spacing={1} alignItems="center">
						<Typography variant="body2">
							Automatické stahování: <strong>{downloadScheduleCron}</strong>
						</Typography>
						<Typography variant="body2" color="text.secondary">
							•
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{enabledCount} z {totalCount} aktivních zdrojů
						</Typography>
					</Stack>
				</Alert>

				<Tooltip title="Obnovit">
					<IconButton
						onClick={handleRefresh}
						size="small"
						sx={{ mb: 1, mr: 1 }}
					>
						<RefreshIcon />
					</IconButton>
				</Tooltip>
			</Stack>

			<DownloadConfigTable
				configs={configs}
				totalCount={totalCount}
				page={page}
				pageSize={pageSize}
				isLoading={isLoading}
				onPageChange={handlePageChange}
				onPageSizeChange={handlePageSizeChange}
				onEdit={setEditConfig}
			/>

			<DownloadConfigDialog
				config={editConfig}
				open={!!editConfig}
				onClose={() => setEditConfig(null)}
			/>
		</Box>
	);
};
